const catalogos = [{
    name: 'tallas',
    caption: 'Tallas',
    url: 'familias'
}, {
    name: 'color',
    caption: 'Colores',
    url: 'presentaciones'
}, {
    name: 'categorias',
    caption: 'Categorias',
    url: 'clasifications'
}, {
    name: 'unidadmedida',
    caption: 'Unidad de Medida',
    url: 'ums'
}, {
    name: 'bancos',
    caption: 'Bancos',
    url: 'banks'
}, {
    name: 'gruponotacredito',
    caption: 'Justificación Nota de Crédito',
    url: 'movementgroups'
}, {
    name: 'cateroria-gastos',
    caption: 'Categoria de Gastos',
    url: 'gastosCategorias'
}];



export default catalogos;